import withCookies from 'flight/mixins/with-cookies';
import { component as defineComponent } from 'flightjs'; // eslint-disable-line no-restricted-imports
export default defineComponent(VisitSourceTracker, withCookies);
function VisitSourceTracker() {
    this.attributes({
        source: 'src',
        cookie: 'projects-visit-source',
        category: 'Projects - visit source',
    });
    this.after('initialize', function() {
        this.trackSource();
        this.on(document, 'uiTrackSourceEvent', this.trackSourceEvent);
    });
    this.trackSource = function() {
        var source = this.getSourceParam();
        if (source && !this.getSourceCookie()) {
            this.setSourceCookie(source);
        }
    };

    this.trackSourceEvent = function(e, data) {
        this.trigger('dataPushAnalytics', {
            data: [
                'send',
                'event',
                this.attr.category,
                data.action,
                this.getSourceCookie(),
                0,
                true,
            ],
        });
    };

    this.setSourceCookie = function(source) {
        return this.setCookie(this.attr.cookie, source, Infinity, '/');
    };

    this.getSourceCookie = function() {
        return this.getCookie(this.attr.cookie);
    };

    this.getSourceParam = function() {
        var results = new RegExp('[?&]' + this.attr.source + '=([^&#]*)').exec(
            this.getLocationHref()
        );
        if (results == null) {
            return null;
        }
        return results[1] || null;
    };

    this.getLocationHref = function() {
        return window.location.href;
    };
}



// WEBPACK FOOTER //
// ./src/js/flight/data/visit-source-tracker.js